import { useLazyQuery, useQuery } from "@apollo/client";
import { PROMPT_FRAGMENTS } from "../prompt-fragment.queries";
import { PromptFragmentsQuery } from "../../../__generated__/PromptFragmentsQuery";

export const usePromptFragments = () => {
  return useQuery<PromptFragmentsQuery>(PROMPT_FRAGMENTS);
};

export const useLazyPromptFragments = () => {
  return useLazyQuery<PromptFragmentsQuery>(PROMPT_FRAGMENTS);
};
